(function (root, factory) {
  var engine = factory();

  if (typeof module === "object" && module.exports) {
    module.exports = engine;
  }

  if (root) {
    root.CombineAndSaveEngine = engine;
  }
})(typeof window !== "undefined" ? window : globalThis, function () {
  "use strict";

  function firstDefined(source, keys) {
    for (var index = 0; index < keys.length; index += 1) {
      var value = source && source[keys[index]];
      if (value !== undefined && value !== null && value !== "") return value;
    }
    return undefined;
  }

  function positiveInteger(value, fallback) {
    var parsed = Number(value);
    if (!Number.isFinite(parsed) || parsed <= 0) return fallback;
    return Math.floor(parsed);
  }

  function normalizeCollectionId(value) {
    if (value && typeof value === "object") {
      value = firstDefined(value, ["id", "collectionId", "admin_graphql_api_id"]);
    }

    if (value === undefined || value === null) return "";
    return String(value).replace("gid://shopify/Collection/", "").trim();
  }

  function normalizeCollectionIds(rawPromotion) {
    var raw = firstDefined(rawPromotion, [
      "collectionIds",
      "collection_ids",
      "eligibleCollectionIds",
      "eligible_collection_ids",
      "collections",
      "eligibleCollections",
    ]);

    if (raw === undefined || raw === null || raw === "") return [];
    if (!Array.isArray(raw)) raw = String(raw).split(",");

    return raw.map(normalizeCollectionId).filter(Boolean);
  }

  function normalizePromotion(rawPromotion) {
    if (!rawPromotion || typeof rawPromotion !== "object") return null;

    var rules = Array.isArray(rawPromotion.rules) ? rawPromotion.rules : [];
    var rule = rules[0] || {};
    var take = positiveInteger(
      firstDefined(rawPromotion, [
        "take",
        "takeQuantity",
        "requiredQuantity",
        "buyQuantity",
        "quantityToTake",
        "x",
      ]),
      positiveInteger(
        firstDefined(rule, [
          "take",
          "takeQuantity",
          "buyQuantity",
          "quantityRequiredToBeGifted",
          "quantityRequiredForDiscount",
          "minimumToBuy",
          "required",
          "x",
        ]),
        0,
      ),
    );

    var pay = positiveInteger(
      firstDefined(rawPromotion, ["pay", "payQuantity", "quantityToPay", "y"]),
      positiveInteger(
        firstDefined(rule, [
          "pay",
          "payQuantity",
          "quantityToPay",
          "quantityRequiredForDiscount",
          "y",
        ]),
        take > 1 ? take - 1 : 0,
      ),
    );

    if (take <= 1 || pay <= 0 || pay >= take) return null;

    var activeValue = firstDefined(rawPromotion, ["active", "activeStatus", "enabled"]);
    var id = firstDefined(rawPromotion, ["id", "promotionId", "promotion_id", "handle"]);

    return {
      id: id === undefined ? "combine-and-save" : String(id),
      title: String(firstDefined(rawPromotion, ["title", "name", "label"]) || ""),
      active: activeValue === undefined ? true : activeValue === true || activeValue === "true",
      take: take,
      pay: pay,
      free: take - pay,
      eligibleUrl: String(firstDefined(rawPromotion, ["eligibleUrl", "collectionUrl"]) || "/collections/all"),
      collectionIds: normalizeCollectionIds(rawPromotion),
      raw: rawPromotion,
    };
  }

  function normalizeItem(rawItem, index) {
    if (!rawItem || typeof rawItem !== "object") return null;

    var quantity = positiveInteger(rawItem.quantity, 0);
    if (!quantity) return null;

    var referenceUnitPrice = Number(
      firstDefined(rawItem, ["referenceUnitPrice", "unitPrice", "originalUnitPrice", "price"]),
    );
    if (!Number.isFinite(referenceUnitPrice) || referenceUnitPrice < 0) referenceUnitPrice = 0;

    var collectionIds = firstDefined(rawItem, ["collectionIds", "collection_ids", "collections"]);
    if (!Array.isArray(collectionIds)) collectionIds = collectionIds ? String(collectionIds).split(",") : [];

    var isFree = rawItem.isFree === true || rawItem.isFree === "true";
    var isCombineFree = rawItem.isCombineFree === true || rawItem.isCombineFree === "true";

    return {
      key: String(firstDefined(rawItem, ["key", "lineKey", "id"]) || "item-" + index),
      quantity: quantity,
      referenceUnitPrice: referenceUnitPrice,
      collectionIds: collectionIds.map(normalizeCollectionId).filter(Boolean),
      order: Number.isFinite(Number(rawItem.order)) ? Number(rawItem.order) : index,
      isFree: isFree,
      isCombineFree: isCombineFree,
      excludeFromCombine: isFree && !isCombineFree,
      raw: rawItem,
    };
  }

  function isEligible(item, promotion) {
    if (!item || !promotion || !promotion.active) return false;
    if (!promotion.collectionIds.length) return true;

    return item.collectionIds.some(function (collectionId) {
      return promotion.collectionIds.indexOf(collectionId) >= 0;
    });
  }

  function expandUnits(items, promotion) {
    var units = [];

    items.forEach(function (rawItem, itemIndex) {
      var item = normalizeItem(rawItem, itemIndex);
      if (!item || item.excludeFromCombine || !isEligible(item, promotion)) return;

      for (var quantityIndex = 0; quantityIndex < item.quantity; quantityIndex += 1) {
        units.push({
          id: item.key + ":" + quantityIndex,
          lineKey: item.key,
          unitIndex: quantityIndex,
          referenceUnitPrice: item.referenceUnitPrice,
          order: item.order,
          raw: item.raw,
          isFree: item.isFree,
        });
      }
    });

    return units;
  }

  function compareCheapest(left, right) {
    if (left.referenceUnitPrice !== right.referenceUnitPrice) {
      return left.referenceUnitPrice - right.referenceUnitPrice;
    }
    // A Function pode separar a mesma variante em uma line paga e outra
    // zerada. No empate de preço-base, usamos a line financeiramente grátis
    // para manter a comunicação de GRÁTIS dentro do conjunto correto.
    if (left.isFree !== right.isFree) return left.isFree ? -1 : 1;
    if (left.order !== right.order) return left.order - right.order;
    return left.unitIndex - right.unitIndex;
  }

  function compareCartOrder(left, right) {
    if (left.order !== right.order) return left.order - right.order;
    return left.unitIndex - right.unitIndex;
  }

  function calculate(items, rawPromotion) {
    var promotion = normalizePromotion(rawPromotion);
    if (!promotion || !promotion.active) {
      return { promotion: promotion, groups: [], eligibleUnits: [], freeUnits: [], completeSetCount: 0 };
    }

    var units = expandUnits(Array.isArray(items) ? items : [], promotion);
    var completeSetCount = Math.floor(units.length / promotion.take);
    var freeUnitCount = completeSetCount * promotion.free;
    // A escolha é global: itens zerados por outra mecânica não ganham
    // prioridade. Em cada múltiplo de X, as unidades de menor preço entre
    // todos os elegíveis são as unidades gratuitas do Combine.
    var freeUnits = units.slice().sort(compareCheapest).slice(0, freeUnitCount);
    var freeIds = new Set(
      freeUnits.map(function (unit) {
        return unit.id;
      }),
    );

    units.forEach(function (unit) {
      unit.isFree = freeIds.has(unit.id);
    });

    var paidUnits = units
      .filter(function (unit) {
        return !unit.isFree;
      })
      .sort(compareCartOrder);
    freeUnits.sort(compareCheapest);

    var groups = [];
    for (var groupIndex = 0; groupIndex < completeSetCount; groupIndex += 1) {
      var groupPaidUnits = paidUnits.slice(groupIndex * promotion.pay, (groupIndex + 1) * promotion.pay);
      var groupFreeUnits = freeUnits.slice(groupIndex * promotion.free, (groupIndex + 1) * promotion.free);
      groups.push({
        index: groupIndex,
        complete: true,
        missing: 0,
        // Mantém a unidade gratuita no fim do conjunto, independentemente da
        // posição original da line no carrinho.
        units: groupPaidUnits.sort(compareCartOrder).concat(groupFreeUnits.sort(compareCartOrder)),
        freeUnits: groupFreeUnits,
      });
    }

    var consumedPaidUnits = completeSetCount * promotion.pay;
    var remainingUnits = paidUnits.slice(consumedPaidUnits).sort(compareCartOrder);
    if (remainingUnits.length) {
      groups.push({
        index: groups.length,
        complete: false,
        missing: Math.max(promotion.take - remainingUnits.length, 0),
        units: remainingUnits,
        freeUnits: [],
      });
    }

    return {
      promotion: promotion,
      groups: groups,
      eligibleUnits: units,
      freeUnits: freeUnits,
      completeSetCount: completeSetCount,
    };
  }

  function wouldBecomeFree(items, candidate, rawPromotion) {
    var marker = "__combine_candidate__";
    var candidateItem = Object.assign({}, candidate, { key: marker, quantity: 1, order: Number.MAX_SAFE_INTEGER });
    var result = calculate((Array.isArray(items) ? items : []).concat(candidateItem), rawPromotion);

    return result.freeUnits.some(function (unit) {
      return unit.lineKey === marker;
    });
  }

  function parseJson(value) {
    if (!value) return null;

    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }

  function directCartItems(container) {
    return Array.prototype.slice.call(container.children).filter(function (child) {
      return child.classList && child.classList.contains("cart-item");
    });
  }

  function cartCopy(doc, attribute) {
    var cartItems = doc.querySelector("#CartDrawer .cart-items");
    return cartItems ? (cartItems.getAttribute(attribute) || "") : "";
  }

  function interpolate(template, replacements) {
    return Object.keys(replacements).reduce(function (value, token) {
      return value.split(token).join(String(replacements[token]));
    }, template || "");
  }

  function createHeader(doc, promotion, group, completeSetCount) {
    var header = doc.createElement("div");
    header.className = "cart-combine-group__header";

    var title = doc.createElement("span");
    title.className = "cart-combine-group__title";
    var setLabel = interpolate(cartCopy(doc, "data-combine-set"), {
      "__NUMBER__": group.index + 1,
    });
    title.textContent = completeSetCount > 1 && group.complete
      ? promotion.title + " - " + setLabel
      : promotion.title;

    var status = doc.createElement("span");
    status.className = "cart-combine-group__status";
    var progressLabel = interpolate(cartCopy(doc, "data-combine-progress"), {
      "__CURRENT__": group.complete ? promotion.take : group.units.length,
      "__TOTAL__": promotion.take,
    });
    status.textContent = group.complete
      ? (completeSetCount > 1 ? cartCopy(doc, "data-combine-complete") : progressLabel)
      : progressLabel;

    header.appendChild(title);
    header.appendChild(status);
    if (group.complete) {
      var indicator = doc.createElement("span");
      indicator.className = "cart-combine-group__indicator";
      indicator.setAttribute("aria-hidden", "true");
      header.appendChild(indicator);
    }
    return header;
  }

  function uniqueUnitsByLine(group) {
    var seen = new Set();

    return group.units.filter(function (unit) {
      if (seen.has(unit.lineKey)) return false;
      seen.add(unit.lineKey);
      return true;
    });
  }

  function unitCountByLine(units) {
    return units.reduce(function (counts, unit) {
      counts[unit.lineKey] = Number(counts[unit.lineKey] || 0) + 1;
      return counts;
    }, {});
  }

  function createCompactSummary(doc, group, elementsByKey) {
    var summary = doc.createElement("div");
    summary.className = "cart-combine-group__summary";

    var images = doc.createElement("div");
    images.className = "cart-combine-group__summary-images";
    var maximumVisibleImages = 4;
    var freeUnitIds = new Set(group.freeUnits.map(function (unit) { return unit.id; }));
    var visibleFreeUnits = group.freeUnits.slice(0, maximumVisibleImages);
    var visiblePaidUnits = group.units.filter(function (unit) {
      return !freeUnitIds.has(unit.id);
    }).slice(0, maximumVisibleImages - visibleFreeUnits.length);
    var visibleUnits = visiblePaidUnits.concat(visibleFreeUnits);

    visibleUnits.forEach(function (unit) {
      var itemElement = elementsByKey[unit.lineKey];
      if (!itemElement) return;

      var image = itemElement.querySelector(".cart-item__image");
      if (!image) return;

      var imageWrapper = doc.createElement("span");
      imageWrapper.className = "cart-combine-group__summary-image";
      if (freeUnitIds.has(unit.id)) {
        imageWrapper.classList.add("is-free");
      }
      imageWrapper.appendChild(image.cloneNode(true));
      images.appendChild(imageWrapper);
    });

    var hiddenUnitCount = Math.max(group.units.length - visibleUnits.length, 0);
    if (hiddenUnitCount > 0) {
      var overflow = doc.createElement("span");
      overflow.className = "cart-combine-group__summary-overflow";
      overflow.setAttribute("aria-label", interpolate(cartCopy(doc, "data-combine-overflow-label"), {
        "__COUNT__": hiddenUnitCount,
      }));
      overflow.textContent = "+" + hiddenUnitCount;
      images.appendChild(overflow);
    }
    images.style.setProperty("--combine-summary-count", String(Math.max(images.children.length, 1)));

    var benefit = doc.createElement("div");
    benefit.className = "cart-combine-group__summary-benefit";
    var freeUnit = group.freeUnits[0];
    var freeItem = freeUnit && elementsByKey[freeUnit.lineKey];
    var freeTitle = freeItem && freeItem.querySelector(".cart-item__name");

    var cartItems = doc.querySelector("#CartDrawer .cart-items");
    var lowestValueLabel = cartItems ? cartItems.getAttribute("data-combine-lowest-value") : "";
    var freeLabel = cartItems ? cartItems.getAttribute("data-combine-free") : "";
    var eyebrow = doc.createElement("span");
    eyebrow.appendChild(doc.createTextNode(lowestValueLabel + " "));
    var highlight = doc.createElement("strong");
    highlight.className = "cart-combine-group__summary-benefit-highlight";
    highlight.textContent = freeLabel;
    eyebrow.appendChild(highlight);
    var value = doc.createElement("strong");
    value.textContent = freeTitle ? freeTitle.textContent.trim() : "";
    benefit.appendChild(eyebrow);
    benefit.appendChild(value);

    summary.appendChild(images);
    summary.appendChild(benefit);
    return summary;
  }

  function createPartialHelp(doc, group, promotion) {
    var help = doc.createElement("div");
    help.className = "cart-combine-group__partial-help";

    var progress = doc.createElement("div");
    progress.className = "cart-combine-group__placeholder";
    var iconBox = doc.createElement("span");
    iconBox.className = "cart-combine-group__placeholder-icon";
    var siteBagIcon = doc.querySelector("#CartDrawer .drawer__heading .icon-cart");
    if (siteBagIcon) {
      var bagIcon = siteBagIcon.cloneNode(true);
      bagIcon.removeAttribute("id");
      bagIcon.setAttribute("aria-hidden", "true");
      iconBox.appendChild(bagIcon);
    }
    var progressText = doc.createElement("strong");
    progressText.textContent = group.missing === 1
      ? cartCopy(doc, "data-combine-add-item")
      : interpolate(cartCopy(doc, "data-combine-add-items"), { "__COUNT__": group.missing });
    var benefit = doc.createElement("span");
    benefit.className = "cart-combine-group__placeholder-benefit";
    benefit.textContent = cartCopy(doc, "data-combine-benefit");
    var link = doc.createElement("a");
    link.href = promotion.eligibleUrl;
    link.textContent = cartCopy(doc, "data-combine-eligible-link");
    progress.appendChild(iconBox);
    progress.appendChild(progressText);
    progress.appendChild(benefit);
    progress.appendChild(link);

    help.appendChild(progress);
    help.setAttribute("data-combine-missing", String(group.missing));
    help.setAttribute("data-combine-take", String(promotion.take));
    return help;
  }

  function removeEmptySourceGroups(cartItems) {
    cartItems.querySelectorAll(":scope > .cart-promo-group, :scope > .cart-no-promo").forEach(function (group) {
      if (!directCartItems(group).length) group.remove();
    });
  }

  function preserveSourceGroupMetadata(itemElement) {
    if (!itemElement || itemElement.hasAttribute("data-source-promo-group-id")) return;

    var sourceGroup = itemElement.closest(".cart-promo-group");
    if (!sourceGroup) return;

    var sourceGroupId = sourceGroup.getAttribute("data-promo-group-id");
    if (sourceGroupId) itemElement.setAttribute("data-source-promo-group-id", sourceGroupId);

    var sourceSchemaType = sourceGroup.getAttribute("data-schema-type");
    if (sourceSchemaType) itemElement.setAttribute("data-source-schema-type", sourceSchemaType);
  }

  function enableCombineLineControls(itemElement) {
    if (!itemElement) return;

    var mode = itemElement.getAttribute("data-quantity-mode") || "native";
    if (mode === "locked") return;

    var input = itemElement.querySelector(".quantity__input");
    if (input) input.disabled = mode !== "native";
    itemElement.querySelectorAll(".quantity__button").forEach(function (button) {
      button.disabled = false;
    });
  }

  function readCandidate(itemElement, order) {
    preserveSourceGroupMetadata(itemElement);
    var isFree = Number(itemElement.getAttribute("data-final-line-price") || 0) === 0;
    var isCombineFree = itemElement.getAttribute("data-combine-is-free") === "true";
    var sourceQuantity = Number(itemElement.getAttribute("data-line-quantity") || 0);

    return {
      key: itemElement.getAttribute("data-cart-key") || "combine-line-" + order,
      quantity: Number(
        itemElement.getAttribute("data-combine-eligible-quantity")
        || itemElement.getAttribute("data-line-quantity")
        || 0,
      ),
      referenceUnitPrice: Number(itemElement.getAttribute("data-reference-unit-price") || 0),
      sourceQuantity: sourceQuantity,
      sourceLinePrices: {
        "data-reference-line-price": Number(itemElement.getAttribute("data-reference-line-price") || 0),
        "data-base-line-price": Number(itemElement.getAttribute("data-base-line-price") || 0),
        "data-commercial-line-price": Number(itemElement.getAttribute("data-commercial-line-price") || 0),
        "data-final-line-price": Number(itemElement.getAttribute("data-final-line-price") || 0),
        "data-coupon-discount": Number(itemElement.getAttribute("data-coupon-discount") || 0),
      },
      collectionIds: String(itemElement.getAttribute("data-colectionsids") || "").split(",").filter(Boolean),
      isFree: isFree,
      isCombineFree: isCombineFree,
      order: order,
      element: itemElement,
      sourceGroup: itemElement.parentElement,
      allocatedQuantity: 0,
    };
  }

  function clearLowestValueLabels(elementsByKey) {
    Object.keys(elementsByKey).forEach(function (lineKey) {
      elementsByKey[lineKey]
        .querySelectorAll(".discounts__discount--combine-lowest-value")
        .forEach(function (label) { label.remove(); });
    });
  }

  function proportionalLinePrice(total, sourceQuantity, startQuantity, targetQuantity) {
    if (!Number.isFinite(total) || sourceQuantity <= 0) return total;
    var endQuantity = Math.min(startQuantity + targetQuantity, sourceQuantity);
    return Math.round(total * endQuantity / sourceQuantity)
      - Math.round(total * startQuantity / sourceQuantity);
  }

  function setGroupPrices(itemElement, quantity, candidate) {
    if (!itemElement || !candidate) return;

    var startQuantity = candidate.allocatedQuantity;
    var allocatedPrices = {};
    Object.keys(candidate.sourceLinePrices).forEach(function (attribute) {
      var value = proportionalLinePrice(
        candidate.sourceLinePrices[attribute],
        candidate.sourceQuantity,
        startQuantity,
        quantity,
      );
      allocatedPrices[attribute] = value;
      itemElement.setAttribute(attribute, String(value));
    });
    candidate.allocatedQuantity = Math.min(startQuantity + quantity, candidate.sourceQuantity);

    itemElement.querySelectorAll("price-normalize").forEach(function (priceElement) {
      priceElement.setAttribute("data-cart-commercial-price", String(allocatedPrices["data-commercial-line-price"]));
      priceElement.setAttribute("data-cart-reference-price", String(allocatedPrices["data-reference-line-price"]));
      priceElement.setAttribute("data-pristine-price", String(allocatedPrices["data-commercial-line-price"]));
      priceElement.setAttribute("data-compare-at-price", String(allocatedPrices["data-reference-line-price"]));
      priceElement.setAttribute("data-timestamp", "combine-group-" + Date.now() + "-" + quantity);
    });
  }

  function makeGroupCopy(itemElement, quantity) {
    var copy = itemElement.cloneNode(true);
    copy.removeAttribute("id");
    copy.setAttribute("data-line-quantity", String(quantity));
    copy.querySelectorAll("[id]").forEach(function (element) { element.removeAttribute("id"); });
    copy.querySelectorAll(".quantity__input").forEach(function (input) {
      input.value = quantity;
      input.min = 0;
    });
    return copy;
  }

  function detachFromCombine(itemElement) {
    var combineAttributes = [
      "data-combine-config",
      "data-combine-id",
      "data-combine-title",
      "data-combine-take",
      "data-combine-pay",
      "data-combine-collection-url",
      "data-combine-is-free",
      "data-combine-eligible-quantity",
      "data-combine-group-quantity",
      "data-combine-line-total-quantity",
    ];

    combineAttributes.forEach(function (attribute) {
      itemElement.removeAttribute(attribute);
    });
    itemElement.querySelectorAll(".quantity__input").forEach(function (input) {
      combineAttributes.forEach(function (attribute) {
        input.removeAttribute(attribute);
      });
    });
  }

  function isolateEligibleQuantity(candidate) {
    var itemElement = candidate.element;
    var totalQuantity = Number(itemElement.getAttribute("data-line-quantity") || 0);
    var eligibleQuantity = Math.max(Math.min(candidate.quantity, totalQuantity), 0);
    var excludedQuantity = totalQuantity - eligibleQuantity;
    if (!excludedQuantity) return;

    var combineElement = makeGroupCopy(itemElement, eligibleQuantity);
    combineElement.setAttribute("data-combine-eligible-quantity", String(eligibleQuantity));
    setGroupQuantity(itemElement, excludedQuantity, totalQuantity, candidate);
    detachFromCombine(itemElement);
    candidate.element = combineElement;
  }

  function setGroupQuantity(itemElement, groupQuantity, totalQuantity, candidate) {
    if (!itemElement) return;
    setGroupPrices(itemElement, groupQuantity, candidate);
    itemElement.setAttribute("data-combine-group-quantity", String(groupQuantity));
    itemElement.setAttribute("data-combine-line-total-quantity", String(totalQuantity));
    itemElement.querySelectorAll(".cart-item__combine-allocation").forEach(function (note) { note.remove(); });

    var input = itemElement.querySelector(".quantity__input");
    if (!input) return;
    input.value = groupQuantity;
    input.min = 0;
    input.setAttribute("data-combine-group-quantity", String(groupQuantity));
    input.setAttribute("data-combine-line-total-quantity", String(totalQuantity));

    var minus = itemElement.querySelector('.quantity__button[name="minus"]');
    if (minus) minus.disabled = false;
  }

  function appendGroupItems(container, group, elementsByKey, candidateByKey, renderedLineKeys) {
    var groupCounts = unitCountByLine(group.units);
    var groupFreeLineKeys = new Set(group.freeUnits.map(function (unit) { return unit.lineKey; }));

    uniqueUnitsByLine(group).forEach(function (unit) {
      var itemElement = elementsByKey[unit.lineKey];
      var candidate = candidateByKey[unit.lineKey];
      if (!itemElement || !candidate) return;

      var groupQuantity = groupCounts[unit.lineKey];
      var targetElement = itemElement;
      if (renderedLineKeys.has(unit.lineKey)) {
        targetElement = makeGroupCopy(itemElement, groupQuantity);
      } else {
        renderedLineKeys.add(unit.lineKey);
        enableCombineLineControls(targetElement);
      }

      setGroupQuantity(targetElement, groupQuantity, candidate.sourceQuantity, candidate);
      targetElement.classList.toggle("cart-item--combine-free", groupFreeLineKeys.has(unit.lineKey));
      container.appendChild(targetElement);
    });
  }

  function renderPromotion(cartItems, candidateElements, rawPromotion, doc) {
    var candidates = candidateElements.map(readCandidate);
    var result = calculate(candidates, rawPromotion);
    if (!result.promotion || !result.groups.length) return false;

    var groupsToRender = result.groups;
    if (!groupsToRender.length) return false;

    candidates.forEach(isolateEligibleQuantity);

    var elementsByKey = candidates.reduce(function (lookup, candidate) {
      lookup[candidate.key] = candidate.element;
      return lookup;
    }, {});
    var candidateByKey = candidates.reduce(function (lookup, candidate) {
      lookup[candidate.key] = candidate;
      return lookup;
    }, {});
    clearLowestValueLabels(elementsByKey);
    var renderedLineKeys = new Set();
    var collection = doc.createElement("div");
    collection.className = "cart-combine-collection";
    collection.setAttribute("data-combine-id", result.promotion.id);
    collection.setAttribute("data-combine-set-count", String(result.completeSetCount));

    groupsToRender.forEach(function (group) {
      var groupElement = doc.createElement(group.complete ? "details" : "div");
      groupElement.className = "cart-combine-group " + (group.complete ? "is-complete" : "is-partial");
      groupElement.setAttribute("data-combine-group", String(group.index + 1));
      groupElement.setAttribute("data-combine-filled", String(group.units.length));

      if (group.complete) {
        groupElement.classList.add("cart-combine-group--compact");
        var toggle = doc.createElement("summary");
        toggle.className = "cart-combine-group__toggle";
        toggle.appendChild(createHeader(doc, result.promotion, group, result.completeSetCount));
        toggle.appendChild(createCompactSummary(doc, group, elementsByKey));
        groupElement.appendChild(toggle);

        var itemList = doc.createElement("div");
        itemList.className = "cart-combine-group__items-list";
        appendGroupItems(itemList, group, elementsByKey, candidateByKey, renderedLineKeys);
        groupElement.appendChild(itemList);
      } else {
        groupElement.appendChild(createHeader(doc, result.promotion, group, result.completeSetCount));
        appendGroupItems(groupElement, group, elementsByKey, candidateByKey, renderedLineKeys);
      }

      if (!group.complete) {
        groupElement.appendChild(createPartialHelp(doc, group, result.promotion));
      }

      collection.appendChild(groupElement);
    });

    cartItems.insertBefore(collection, cartItems.firstChild);
    return true;
  }

  function renderCartDrawer(rootNode) {
    if (typeof document === "undefined") return false;

    var scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
    var cartItems = scope.matches && scope.matches(".cart-items")
      ? scope
      : scope.querySelector("#CartDrawer .cart-items");
    if (!cartItems || cartItems.getAttribute("data-combine-organized") === "true") return false;

    // Resolve as comunicações das mecânicas originais antes de mover as
    // mesmas lines para os conjuntos visuais do Combine.
    if (typeof window.refreshCupinnCartPromoMessages === "function") {
      window.refreshCupinnCartPromoMessages();
    }

    cartItems.setAttribute("data-combine-organized", "true");
    cartItems.querySelectorAll(".cart-promo-group .cart-item").forEach(function (itemElement) {
      preserveSourceGroupMetadata(itemElement);
    });
    var eligibleItems = Array.prototype.slice.call(
      cartItems.querySelectorAll(".cart-item[data-combine-id][data-combine-config]"),
    ).filter(function (itemElement) {
      return Number(
        itemElement.getAttribute("data-combine-eligible-quantity")
        || itemElement.getAttribute("data-line-quantity")
        || 0,
      ) > 0;
    });
    if (!eligibleItems.length) return false;

    var candidatesByPromotion = eligibleItems.reduce(function (groups, itemElement) {
      var id = itemElement.getAttribute("data-combine-id") || "combine-and-save";
      if (!groups[id]) groups[id] = [];
      groups[id].push(itemElement);
      return groups;
    }, {});
    var rendered = false;

    Object.keys(candidatesByPromotion).forEach(function (promotionId) {
      var candidateElements = candidatesByPromotion[promotionId];
      var rawPromotion = parseJson(candidateElements[0].getAttribute("data-combine-config"));
      if (!rawPromotion) return;

      rawPromotion.id = promotionId;
      rawPromotion.title = candidateElements[0].getAttribute("data-combine-title") || rawPromotion.title;
      rawPromotion.requiredQuantity = candidateElements[0].getAttribute("data-combine-take") || rawPromotion.requiredQuantity;
      rawPromotion.payQuantity = candidateElements[0].getAttribute("data-combine-pay") || rawPromotion.payQuantity;
      rawPromotion.eligibleUrl = candidateElements[0].getAttribute("data-combine-collection-url") || rawPromotion.eligibleUrl;
      rendered = renderPromotion(cartItems, candidateElements, rawPromotion, document) || rendered;
    });

    if (!rendered) return false;

    removeEmptySourceGroups(cartItems);
    document.dispatchEvent(new CustomEvent("cart:combine-organized"));
    return true;
  }

  return {
    calculate: calculate,
    isEligible: isEligible,
    normalizeItem: normalizeItem,
    normalizePromotion: normalizePromotion,
    renderCartDrawer: renderCartDrawer,
    wouldBecomeFree: wouldBecomeFree,
  };
});

(function initCombineAndSaveCartDrawer(root) {
  if (!root || typeof document === "undefined") return;
  if (root.__insider_combineAndSaveCartDrawerInit) return;
  root.__insider_combineAndSaveCartDrawerInit = true;

  // Uma line do Shopify pode alimentar mais de um conjunto visual. Cada
  // representação mostra só a quantidade daquele conjunto; antes do handler
  // nativo do carrinho, convertemos a variação visual na nova quantidade total
  // da line real.
  document.addEventListener("change", function (event) {
    var input = event.target && event.target.closest
      ? event.target.closest("#CartDrawer .quantity__input[data-combine-group-quantity]")
      : null;
    if (!input) return;

    var groupQuantity = Number(input.getAttribute("data-combine-group-quantity"));
    var totalQuantity = Number(input.getAttribute("data-combine-line-total-quantity"));
    var requestedGroupQuantity = Number(input.value);
    if (![groupQuantity, totalQuantity, requestedGroupQuantity].every(Number.isFinite)) return;

    input.value = Math.max(totalQuantity + requestedGroupQuantity - groupQuantity, 0);
  }, true);

  var scheduled = false;
  function scheduleRender() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      if (root.CombineAndSaveEngine) root.CombineAndSaveEngine.renderCartDrawer(document);
    }, 0);
  }

  document.addEventListener("DOMContentLoaded", scheduleRender, { once: true });
  ["cart:updated", "cart:change", "cart:refresh", "cart:requestComplete", "quantity:change"].forEach(function (eventName) {
    document.addEventListener(eventName, scheduleRender);
  });

  var cartDrawer = document.querySelector("#CartDrawer");
  if (cartDrawer && "MutationObserver" in root) {
    new MutationObserver(scheduleRender).observe(cartDrawer, {
      childList: true,
      subtree: true,
    });
  }

  scheduleRender();
})(typeof window !== "undefined" ? window : null);

(function initCombineAndSavePdp(root) {
  if (!root || typeof document === "undefined" || !root.customElements) return;
  if (root.customElements.get("combine-and-save-pdp")) return;

  function parseJson(value, fallback) {
    try {
      return JSON.parse(value);
    } catch (error) {
      return fallback;
    }
  }

  function readCartCandidates(promotionId) {
    var lines = Array.prototype.slice.call(
      document.querySelectorAll("#CartDrawer .cart-item[data-combine-id][data-cart-key]"),
    ).filter(function (line) {
      return !promotionId || line.getAttribute("data-combine-id") === promotionId;
    });
    var byKey = {};

    lines.forEach(function (line, index) {
      var key = line.getAttribute("data-cart-key") || "combine-pdp-line-" + index;
      var totalQuantity = Number(
        line.getAttribute("data-combine-eligible-quantity")
        || line.getAttribute("data-line-quantity")
        || 0,
      );
      var existing = byKey[key];
      if (existing && existing.quantity >= totalQuantity) return;

      byKey[key] = {
        key: key,
        quantity: totalQuantity,
        referenceUnitPrice: Number(line.getAttribute("data-reference-unit-price") || 0),
        collectionIds: String(line.getAttribute("data-colectionsids") || "").split(",").filter(Boolean),
        isFree: Number(line.getAttribute("data-final-line-price") || 0) === 0,
        isCombineFree: line.getAttribute("data-combine-is-free") === "true",
        order: index,
      };
    });

    return Object.keys(byKey).map(function (key) { return byKey[key]; });
  }

  function replaceCount(template, count) {
    return String(template || "").replace(/__COUNT__/g, String(count));
  }

  function replaceOrdinal(template, ordinal) {
    return String(template || "").replace(/__ORDINAL__/g, String(ordinal));
  }

  class CombineAndSavePdp extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.variants = parseJson(this.querySelector("[data-combine-variants]")?.textContent || "[]", []);
      this.titleNode = this.querySelector(".combine-and-save-pdp__title");
      this.descriptionNode = this.querySelector(".combine-and-save-pdp__description");
      this.form = document.getElementById(this.dataset.productFormId);
      this.productInfo = this.closest("[data-product-info], product-info");
      this.context = this.dataset.context || "product";
      this.kitSelector = this.context === "pdk" ? this.productInfo?.querySelector("kit-variant-selector") : null;
      this.kitItem = this.context === "pdk" ? this.closest("kit-item") : null;
      this.update = this.update.bind(this);
      this.scheduleUpdate = function () { setTimeout(this.update, 0); }.bind(this);
      this.handleSelectionChange = this.handleSelectionChange.bind(this);
      this.handleKitClick = this.handleKitClick.bind(this);
      this.cartEvents = ["cart:updated", "cart:change", "cart:refresh", "cart:requestComplete", "cart:combine-organized"];

      if (this.productInfo) this.productInfo.addEventListener("change", this.handleSelectionChange);
      if (this.kitSelector) this.kitSelector.addEventListener("click", this.handleKitClick);
      this.cartEvents.forEach(
        function (eventName) { document.addEventListener(eventName, this.update); }.bind(this),
      );
      this.update();
    }

    disconnectedCallback() {
      if (!this.initialized) return;
      if (this.productInfo) this.productInfo.removeEventListener("change", this.handleSelectionChange);
      if (this.kitSelector) this.kitSelector.removeEventListener("click", this.handleKitClick);
      this.cartEvents.forEach(
        function (eventName) { document.removeEventListener(eventName, this.update); }.bind(this),
      );
      this.initialized = false;
    }

    selectedVariant() {
      if (!this.form) this.form = document.getElementById(this.dataset.productFormId);
      var input = this.form && this.form.querySelector('[name="id"]');
      var selectedId = Number(input && input.value);
      if (!selectedId) return null;
      return this.variants.find(function (variant) { return Number(variant.id) === selectedId; }) || null;
    }

    handleSelectionChange(event) {
      var optionInput = event.target && event.target.closest
        ? event.target.closest('input[data-position], select[name^="options["]')
        : null;

      if (this.context === "pdk" && event.isTrusted && optionInput) {
        var kitItem = optionInput.closest("kit-item");
        if (kitItem) kitItem.dataset.combineUserSelected = "true";
      }

      this.scheduleUpdate();
    }

    handleKitClick(event) {
      var navigationButton = event.target.closest(".product-form__next-btn, .product-form__previous-btn");
      if (!navigationButton) return;

      if (navigationButton.matches(".product-form__next-btn")) {
        var currentIndex = this.kitSelector?.kitItemsSlider?.currentIndex?.();
        var currentItem = this.kitSelector.querySelector('kit-item[data-index="' + Number(currentIndex || 0) + '"]');
        if (currentItem?.currentVariant) currentItem.dataset.combineUserSelected = "true";
      }
      this.scheduleUpdate();
    }

    promotionConfig() {
      var config = parseJson(this.dataset.promotionConfig || "{}", {});
      config.title = this.dataset.promotionTitle || config.title;
      config.requiredQuantity = Number(this.dataset.promotionTake || config.requiredQuantity);
      config.payQuantity = Number(this.dataset.promotionPay || config.payQuantity);
      return config;
    }

    startMessage(calculation) {
      var ordinalIndex = Number(calculation.completeSetCount || 0);
      var ordinals = String(this.dataset.startOrdinals || "").split(",").map(function (value) {
        return value.trim();
      }).filter(Boolean);
      var ordinal = ordinals[ordinalIndex] || this.dataset.startNext;
      return replaceOrdinal(this.dataset.startTemplate, ordinal);
    }

    renderDescription(rule, status) {
      var marker = "__ELIGIBLE_ITEMS__";
      var parts = String(rule || "").split(marker);
      this.descriptionNode.textContent = "";

      if (parts.length > 1 && this.dataset.promotionEligibleUrl) {
        this.descriptionNode.appendChild(document.createTextNode(parts.shift()));
        var link = document.createElement("a");
        link.href = this.dataset.promotionEligibleUrl;
        link.textContent = this.dataset.eligibleItemsLabel || marker;
        this.descriptionNode.appendChild(link);
        this.descriptionNode.appendChild(document.createTextNode(parts.join(marker)));
      } else {
        this.descriptionNode.appendChild(document.createTextNode(
          String(rule || "").replace(marker, this.dataset.eligibleItemsLabel || ""),
        ));
      }

      if (status) this.descriptionNode.appendChild(document.createTextNode(" " + status));
    }

    renderState(calculation, take, progress, becomesFree) {
      this.classList.toggle("is-free-candidate", becomesFree);
      this.titleNode.textContent = becomesFree ? this.dataset.freeTitle : this.dataset.defaultTitle;

      var rule = replaceCount(this.dataset.ruleTemplate, take);
      var completedSets = Number(calculation.completeSetCount || 0);
      var progressTemplate = completedSets === 0
        ? this.dataset.progressFirstTemplate
        : completedSets === 1
          ? this.dataset.progressOneTemplate
          : this.dataset.progressManyTemplate;
      var progressStatus = String(progressTemplate || "")
        .replace(/__SETS__/g, String(completedSets))
        .replace(/__COUNT__/g, String(progress))
        .replace(/__TAKE__/g, String(take));
      var status = progress === 0
        ? this.startMessage(calculation)
        : becomesFree
          ? replaceCount(this.dataset.freeTemplate, progress)
          : progressStatus;
      this.renderDescription(rule, status);
    }

    updateProduct(engine, config) {
      var candidates = readCartCandidates(this.dataset.promotionId);
      var calculation = engine.calculate(candidates, config);
      var take = calculation.promotion ? calculation.promotion.take : Number(this.dataset.promotionTake || 0);
      var progress = take ? calculation.eligibleUnits.length % take : calculation.eligibleUnits.length;
      var variant = this.selectedVariant();
      var becomesFree = variant && variant.available !== false
        ? engine.wouldBecomeFree(candidates, {
            quantity: 1,
            referenceUnitPrice: Number(variant.price || 0),
            collectionIds: [],
            isFree: false,
          }, config)
        : false;

      this.hidden = false;
      this.renderState(calculation, take, progress, becomesFree);
    }

    kitCandidate(kitItem) {
      var variant = kitItem?.currentVariant;
      if (
        !variant
        || variant.available === false
        || kitItem?.dataset.combineUserSelected !== "true"
        || kitItem?.dataset.combineEligible !== "true"
      ) return null;
      return {
        key: "combine-pdk-item-" + kitItem.dataset.index,
        quantity: Number(kitItem.quantity || kitItem.dataset.quantity || 1),
        referenceUnitPrice: Number(variant.price || 0),
        collectionIds: [],
        isFree: false,
        order: 10000 + Number(kitItem.dataset.index || 0),
      };
    }

    updatePdk(engine, config) {
      if (!this.kitSelector) {
        this.hidden = true;
        return;
      }

      var currentItem = this.kitItem;
      var currentIndex = Number(currentItem?.dataset.index || 0);
      var currentEligible = currentItem?.dataset.combineEligible === "true";
      this.hidden = !currentEligible;
      if (!currentEligible) return;

      var cartCandidates = readCartCandidates(this.dataset.promotionId);
      var selectedCandidates = Array.prototype.slice.call(this.kitSelector.querySelectorAll("kit-item"))
        .filter(function (item) { return Number(item.dataset.index || 0) < currentIndex; })
        .map(this.kitCandidate.bind(this))
        .filter(Boolean);
      var baseCandidates = cartCandidates.concat(selectedCandidates);
      var baseCalculation = engine.calculate(baseCandidates, config);
      var currentCandidate = this.kitCandidate(currentItem);
      var becomesFree = false;

      if (currentCandidate) {
        var withCurrent = engine.calculate(baseCandidates.concat(currentCandidate), config);
        becomesFree = withCurrent.freeUnits.some(function (unit) {
          return unit.lineKey === currentCandidate.key;
        });
      }

      var take = baseCalculation.promotion
        ? baseCalculation.promotion.take
        : Number(this.dataset.promotionTake || 0);
      this.classList.toggle("is-free-candidate", becomesFree);
      this.titleNode.textContent = becomesFree ? this.dataset.freeTitle : this.dataset.defaultTitle;

      var selectedWithCurrent = selectedCandidates.slice();
      if (currentCandidate) selectedWithCurrent.push(currentCandidate);
      var selectedKitCount = selectedWithCurrent.reduce(function (total, candidate) {
        return total + Number(candidate.quantity || 0);
      }, 0);
      var cartCalculation = engine.calculate(cartCandidates, config);
      var cartCount = cartCalculation.eligibleUnits.length;
      var rule = replaceCount(this.dataset.ruleTemplate, take);
      var kitTemplate = selectedKitCount === 1
        ? this.dataset.pdkKitOneTemplate
        : this.dataset.pdkKitManyTemplate;
      var cartTemplate = cartCount === 1
        ? this.dataset.pdkCartOneTemplate
        : this.dataset.pdkCartManyTemplate;
      var kitStatus = replaceCount(kitTemplate, selectedKitCount);
      var cartStatus = cartCount > 0 ? replaceCount(cartTemplate, cartCount) : "";
      if (!cartStatus) kitStatus += ".";
      this.renderDescription(rule, kitStatus + cartStatus);
    }

    update() {
      var engine = root.CombineAndSaveEngine;
      var config = this.promotionConfig();
      if (!engine || !config) return;
      if (this.context === "pdk") this.updatePdk(engine, config);
      else this.updateProduct(engine, config);
    }
  }

  root.customElements.define("combine-and-save-pdp", CombineAndSavePdp);
})(typeof window !== "undefined" ? window : null);
